module.exports = __webpack_public_path__ + "static/media/zw.80632a3c.svg";